import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICWQuestion } from '../../../../../../../Common/model/cwquestion';
import { RoutingService } from '../../../../services/routing-service/routing.service';
import { EditQuestionData } from '../edit-question.component';

@Component({
  selector: 'app-edit-question-dialog',
  templateUrl: './edit-question-dialog.component.html',
})
export class EditQuestionDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public editQuestionData: EditQuestionData,
    private matDialogRef: MatDialogRef<EditQuestionDialogComponent>,
  ) {}

  onCancel(): void {
    this.matDialogRef.close();
  }
  onSave(cwQuestion: ICWQuestion): void {
    this.matDialogRef.close(cwQuestion);
  }
  onClickHeader(): void {
    this.matDialogRef.close();
    RoutingService.createEditQuestion.navigateTo({
      param: this.editQuestionData.cwQuestion.base.indexId.toString(),
      queryParam: this.editQuestionData.crosswordBuildId,
    });
  }
}
